export default __webpack_public_path__ + "static/media/signOut.a0390338.svg";